import React from "react";
import { Route, Routes } from "react-router";
import DisclaimerStartPage from "../../views/all-disclaimer/disclaimer-start-page";
import Login from "../../views/agency/login/Login";
import Register from "../../views/agency/register/Register";
import RecoverPassword from "../../views/agency/recover/RecoverPassword";
import AttorneyCivilQuery from "../../views/case-query/Civil Query/AttorneyCivilQuery";
import CivilQuery from "../../views/case-query/Civil Query/CivilQuery";
import DailyCivilQuery from "../../views/case-query/Civil Query/DailyCivilQuery";
import AgencyQuery from "../../views/case-query/TR-CR-Query/AgencyQuery";
import ArraignmentQuery from "../../views/case-query/TR-CR-Query/ArraignmentQuery";
import AttorneyQuery from "../../views/case-query/TR-CR-Query/AttorneyQuery";
import DailyQuery from "../../views/case-query/TR-CR-Query/DailyQuery";
import ScheduleCriminalQuery from "../../views/case-query/TR-CR-Query/ScheduleCriminalQuery";
import CivilLookup from "../../views/civil/civil-lookup";
import CivilDetail from "../../views/civil/detail/civil-detail";
import Contact from "../../views/court-menu/Contact";
import CaseDetail from "../../views/detail/case-detail";
import Home from "../../views/home";
import NotFound from "../../views/not-found";
import TrafficCriminalLookup from "../../views/traffic-criminal/traffic-criminal-lookup";
import ActiveWarrants from "../../views/warrants/active-warrants";
import AuthedLayout from "../layout/AuthedLayout";
import QueryListPage from "../../views/schedule-quey-list-page/query-list-page";
import TrafficCriminalPayment from "../../views/payment/TrafficCriminalPayment";
import PaymentForm from "../../views/payment/paymentForm";
import Profile from "../../views/agency/profile/profile";
import EFile from "../../views/e-file/EFile";
import EFileQuestions from "../../views/e-file/EFileQuestions";
import EFileReview from "../../views/e-file/EFileReview";
import NewCivilCase from "../../views/civil/new-case/newCivilCase";
import getConfigs from "../../GetConfigs";

const Router = () => {
const configurations = getConfigs([
  "ctTRCRLookup",
  "ctCVLookup",
  "ctTRCRSchedQuery",
  "ctCVLSchedQuery",
  "ctActiveWarrantsPage",
  "cvEfilePage"
]);
  return (
    <Routes>
      <Route element={<AuthedLayout>{React.createElement(NotFound)}</AuthedLayout>} path="*" />
      <Route element={<AuthedLayout>{React.createElement(DisclaimerStartPage)}</AuthedLayout>} path="/" />
      <Route element={<AuthedLayout>{React.createElement(Login)}</AuthedLayout>} path="/login" />
      <Route element={<AuthedLayout>{React.createElement(Register)}</AuthedLayout>} path="/register" />
      <Route element={<AuthedLayout>{React.createElement(RecoverPassword)}</AuthedLayout>} path="/recover" />
      <Route element={<AuthedLayout>{React.createElement(Home)}</AuthedLayout>} path="/home" />
      <Route element={<AuthedLayout>{configurations.ctTRCRLookup == "false" ? React.createElement(NotFound) : React.createElement(TrafficCriminalLookup)}</AuthedLayout>} path="/lookup" />
      <Route element={<AuthedLayout>{React.createElement(CaseDetail)}</AuthedLayout>} path="/lookup/detail" />
      <Route element={<AuthedLayout>{configurations.ctActiveWarrantsPage == "false" ? React.createElement(NotFound) : React.createElement(ActiveWarrants)}</AuthedLayout>} path="/warrants" />
      <Route element={<AuthedLayout>{React.createElement(CaseDetail)}</AuthedLayout>} path="/warrant/detail" />
      <Route element={<AuthedLayout>{configurations.ctCVLookup == "false" ? React.createElement(NotFound) : React.createElement(CivilLookup)}</AuthedLayout>} path="/civil" />
      <Route element={<AuthedLayout>{React.createElement(CivilDetail)}</AuthedLayout>} path="/civil/civil-detail" />
      <Route element={<AuthedLayout>{configurations.ctTRCRSchedQuery == "false" ? React.createElement(NotFound) : React.createElement(ScheduleCriminalQuery)}</AuthedLayout>} path="/tr-cr-query" />
      <Route element={<AuthedLayout>{React.createElement(DailyQuery)}</AuthedLayout>} path="/tr-cr-query/daily-query" />
      <Route element={<AuthedLayout>{React.createElement(QueryListPage)}</AuthedLayout>} path="/tr-cr-query/daily-query/list" />
      <Route element={<AuthedLayout>{React.createElement(ArraignmentQuery)}</AuthedLayout>} path="/tr-cr-query/arraignment-query" />
      <Route element={<AuthedLayout>{React.createElement(QueryListPage)}</AuthedLayout>} path="/tr-cr-query/arraignment-query/list" />
      <Route element={<AuthedLayout>{React.createElement(AttorneyQuery)}</AuthedLayout>} path="/tr-cr-query/attorney-query" />
      <Route element={<AuthedLayout>{React.createElement(QueryListPage)}</AuthedLayout>} path="/tr-cr-query/attorney-query/list" />
      <Route element={<AuthedLayout>{React.createElement(AgencyQuery)}</AuthedLayout>} path="/tr-cr-query/agency-query" />
      <Route element={<AuthedLayout>{React.createElement(QueryListPage)}</AuthedLayout>} path="/tr-cr-query/agency-query/list" />
      <Route element={<AuthedLayout>{configurations.ctCVLSchedQuery == "false" ? React.createElement(NotFound) : React.createElement(CivilQuery)}</AuthedLayout>} path="/civil-query" />
      <Route element={<AuthedLayout>{React.createElement(DailyCivilQuery)}</AuthedLayout>} path="/civil-query/daily-query" />
      <Route element={<AuthedLayout>{React.createElement(QueryListPage)}</AuthedLayout>} path="/civil-query/daily-query/list" />
      <Route element={<AuthedLayout>{React.createElement(AttorneyCivilQuery)}</AuthedLayout>} path="/civil-query/attorney-query" />
      <Route element={<AuthedLayout>{React.createElement(QueryListPage)}</AuthedLayout>} path="/civil-query/attorney-query/list" />
      <Route element={<AuthedLayout>{React.createElement(Contact)}</AuthedLayout>} path="/contact" />
      <Route element={<AuthedLayout>{React.createElement(TrafficCriminalPayment)}</AuthedLayout>} path="/detail/pay" />
      <Route element={<AuthedLayout>{React.createElement(PaymentForm)}</AuthedLayout>} path="/pay" />
      <Route element={<AuthedLayout>{React.createElement(Profile)}</AuthedLayout>} path="/profile" />
      <Route element={<AuthedLayout>{React.createElement(EFile)}</AuthedLayout>} path="/efile" />
      <Route element={<AuthedLayout>{React.createElement(EFileQuestions)}</AuthedLayout>} path="/efile/questions" />
      <Route element={<AuthedLayout>{React.createElement(EFileReview)}</AuthedLayout>} path="/efile/questions/review" />
      <Route element={<AuthedLayout>{configurations.cvEfilePage == "false" ? React.createElement(NotFound) : React.createElement(NewCivilCase)}</AuthedLayout>} path="/civil/new" />
    </Routes>
  );
};

export default Router;
